import type { OrganisationEntry } from '../session';
import { sw } from './messages';

/** An organisation's own `capabilities` derive from its tenant-wide rows alone,
 *  and only a tenant-wide `TENANT_ADMIN` row grants this one: the role cannot be
 *  scoped to a campaign (core's `ck_memberships_role_scope`). */
const ORG_ADMIN_CAPABILITY = 'control_plane.write';
const READ_CAPABILITY = 'control_plane.read';

export function isOrgAdmin(organisation: Pick<OrganisationEntry, 'capabilities'>): boolean {
  return organisation.capabilities.includes(ORG_ADMIN_CAPABILITY);
}

export function roleLabel(organisation: Pick<OrganisationEntry, 'capabilities'>): string | null {
  if (isOrgAdmin(organisation)) return sw('role.orgAdmin');
  if (organisation.capabilities.includes(READ_CAPABILITY)) return sw('role.analyst');
  return null;
}
